import React from 'react'
import { Link } from 'react-router-dom'

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-neutral-900">404</h1>
        <h2 className="mt-4 text-2xl font-semibold text-neutral-700">Page not found</h2>
        <p className="mt-2 text-neutral-600">Sorry, we couldn't find the page you're looking for.</p>
        <div className="mt-6">
          <Link
            to="/"
            className="btn-primary"
          >
            Go back home
          </Link>
        </div>
      </div>
    </div>
  )
}